import styled, { css, DefaultTheme } from "styled-components";
import { AccordionVariantEnum } from "./Accordion";

export const StyledAccordion = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AccordionHeader = styled.div<{
  $isCollapsible: boolean;
  $variant: AccordionVariantEnum;
}>`
  background-color: ${({ theme, $variant }) =>
    $variant === "secondary" ? theme.colors.white : theme.colors.grey_6};
  cursor: ${(props) => (props.$isCollapsible ? "pointer" : "unset")};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: ${({ $variant }) => ($variant === "primary" ? "12px" : "0")};

  & .accordion-header-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
`;

const variantStyles = (
  theme: DefaultTheme,
  variant: AccordionVariantEnum,
  $isOpen: boolean,
) =>
  ({
    primary: css`
      top: -8px;
      margin-bottom: ${$isOpen ? "-8px" : "unset"};
      background-color: ${theme.colors.grey_6};
    `,
    secondary: css`
      background-color: ${theme.colors.white};
    `,
  })[variant];

export const AccordionContent = styled.div<{
  $isOpen: boolean;
  $variant: AccordionVariantEnum;
  $toScroll?: boolean;
}>`
  ${({ theme, $variant, $isOpen }) => variantStyles(theme, $variant, $isOpen)};
  position: relative;
  max-height: ${(props) => (props.$isOpen ? "100%" : "0px")};
  opacity: ${(props) => (props.$isOpen ? "1" : "0")};
  border-radius: 0px 0px 8px 8px;
  transition:
    opacity 0.3s ease-out,
    max-height 0.3s ease-out;
  display: ${(props) => (props.$toScroll ? "flex" : "auto")};
`;

export const AccordionIcon = styled.span<{ $isOpen: boolean }>`
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.4s ease-out;
  margin-left: 6px;
`;
